module.exports = __webpack_public_path__ + "static/media/ibopad4.89341afc.png";